import { createTheme } from '@mui/material/styles';
import { themeOptions } from './themeOptions';

export const theme = createTheme(themeOptions);
